export class ExtraDataSearchRequest {
    public SearchType: ExtraDataSearchType;
    public ReferenceId: string;
    public ReferenceType: ReferenceType;

    public constructor(obj?: Partial<ExtraDataSearchRequest>) {
        if (obj != null)
            Object.assign(this, obj);
    }
}

export enum ExtraDataSearchType {
    ByRefIdAndRefType = 0
}

export enum ReferenceType {
    Order = 0,
    Customer = 1,
    Agent = 2
}


// WEBPACK FOOTER //
// ./app/objects/extraData/extraDataSearchRequest.ts